import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { observer } from 'mobx-react'
import { computed, action } from 'mobx'
import { FormField } from 'helpers/formField'

import TextField from 'material-ui/TextField'

@observer
export default class FormInput extends Component {

  static propTypes = {
    field: PropTypes.instanceOf(FormField).isRequired,
    TextFieldProps: PropTypes.object
  }

  static defaultProps = {
    TextFieldProps: {}
  }

  @computed
  get field() {
    return this.props.field
  }

  @computed
  get helperText() {
    const { helperText = '' } = this.props.TextFieldProps
    const { hasErrors, errors } = this.field
    return hasErrors ? errors[0] : helperText
  }

  @computed
  get normalizedProps() {
    const { value, name, label, type, disabled } = this.field

    return Object.assign({}, this.props.TextFieldProps, {
      value,
      name,
      label,
      type,
      disabled,
      error: this.field.hasErrors,
      helperText: this.helperText,
      onChange: this.handleChange
    })
  }

  render() {
    return (
      <TextField { ...this.normalizedProps } />
    )
  }

  @action.bound
  handleChange({ target: { value }}) {
    this.field.setValue(value)
  }

}



// WEBPACK FOOTER //
// ./src/components/forms/FormInput.js